import React from 'react';

const DeclaracionesJuradas = () => {




    return (
        
            <div className="contenedor-tablas">

                <table className="mi-tabla">

                    <caption> DECLARACIONES JURADAS </caption>

                    <tr>
                        <td>Formato PDF  👉 <a href='./Descargas/Docentes/declaracion jurada - PDF.pdf' target="_blank" className="linksD" ><button>Click Aca</button></a></td>
                        <td>Formato WORD 👉 <a href='./Descargas/Docentes/declaracion jurada - WORD.docx' target="_blank" className="linksD" ><button>Click Aca</button></a></td>
                    </tr>
                    
                </table>
            </div>
  
    );
}

export default DeclaracionesJuradas;
